import { makeRequest } from '../../services/apiClient'
import { ELanguage } from '@microfrontends/app-shell-v2'

const apiSearchJobUrl = `${process.env.API_DOMAIN}/job-search/v1.0/search`
const imgBaseUrl = `${process.env.IMAGE_BASE_URL}`

export function generateJobUrl(jobAlias, jobId, language = '', utmString = '') {
	let linkJob = process.env.VNW_BASE_URL + '/' + jobAlias + '-' + jobId
	if (language === 'en') {
		linkJob += '-jd'
	} else {
		linkJob += '-jv'
	}
	if (utmString.length > 0) {
		linkJob += '?' + utmString
	}
	return linkJob
}

export default async function dataSource(language, body) {
	let result = {}
	if (body === false) {
		return []
	}
	try {
		result = await makeRequest(apiSearchJobUrl, 'post', body)

		if (!!result) {
			return result.data.map((item) => {
				return {
					...item,
					title: item.jobTitle,
					company: item.isAnonymous
						? "Vietnamworks' Client"
						: item.companyName,
					locations: item.workingLocations.map((location) =>
						language === ELanguage.EN
							? location.cityName
							: location.cityNameVI
					),
					logo: item.companyLogo,
					url: item.url
						? item.url
						: generateJobUrl(item.alias, item.jobId, language, ''),
					isAnonymous: item.isAnonymous,
					companyId: item.companyId
				}
			})
		}
		return []
	} catch (err) {
		return []
	}
}
